import { z } from 'zod/v4';

export const TracingAttachmentSchema = z.object({
  /** An uploaded file's id. */
  fileId: z.string().min(1),
  type: z.string().min(1),
  name: z.string().optional(),
  reference: z.string().optional(),
  description: z.string().optional(),
});

export type TracingAttachment = z.infer<typeof TracingAttachmentSchema>;

export const BulkOrderDocumentsBodySchema = z.object({
  /** At least one, none empty, no repeats. Ids that are not the caller's orders are skipped. */
  ids: z
    .array(z.string().min(1))
    .min(1)
    .refine(ids => new Set(ids).size === ids.length, {
      message: 'ids must be unique',
    }),
  attachments: z.array(TracingAttachmentSchema),
});

export type BulkOrderDocumentsBody = z.infer<
  typeof BulkOrderDocumentsBodySchema
>;

/** Error codes the bulk documents update answers with. */
export const BULK_ORDER_DOCUMENTS_ERROR_CODES = {
  /** 409 — the orders do not all share one attachment template. */
  DIFFERENT_ATTACHMENT_TEMPLATES:
    'orders_must_have_the_same_attachment_template_ids',
} as const;
